import React from 'react';
import { motion } from 'framer-motion';
import { SectionMarker } from './SectionMarker';
import { CheckItem } from './CheckItem';
export function WhatChangesSection() {
  return <section className="w-full bg-navy-dark py-10 md:py-14" data-id="element-193">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-195">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-196">
            <SectionMarker data-id="element-197" />
            <span className="text-cream-muted text-sm uppercase tracking-wider" data-id="element-198">
              Transformación
            </span>
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-4" data-id="element-199">
            Qué cambia cuando regulas la alerta
          </h2>

          <p className="text-lg text-cream-muted" data-id="element-200">
            No te prometo dormir perfecto.
          </p>
          <p className="font-playfair text-xl md:text-2xl italic text-amber mt-2" data-id="element-201">
            Te prometo esto:
          </p>
        </motion.div>

        <div className="space-y-5 mb-10" data-id="element-202">
          <CheckItem delay={0.1} data-id="element-203">Menos ansiedad</CheckItem>
          <CheckItem delay={0.15} data-id="element-204">Más control</CheckItem>
          <CheckItem delay={0.2} data-id="element-205">Más rapidez para volver a dormir</CheckItem>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-206">
          <p className="text-lg text-cream-muted mb-3" data-id="element-207">
            Pasas de sentirte víctima de tus noches…
          </p>
          <p className="text-xl md:text-2xl text-amber font-medium" data-id="element-208">
            a sentir que sabes qué hacer.
          </p>
        </motion.div>
      </div>
    </section>;
}